/*
    This component exists to help format the offseason messages that are returned from the API.
    The reason we need it currently is because the URL's in the message are being returned as plain text,
    and not wrapped in anchor (<a href="foo.com">Click me!</a>) tags.
       *** Temporary Component to patch us over until the response from the API is fixed ***
*/

import * as Seasons from '@avcan/constants/products/offseason/seasons'

function offSeason(message) {
    return message
        .replace(
            'http://www.mountainconditions.com.',
            '<a href="https://www.mountainconditions.ca" target="_blank" rel="nofollow">Mountain Conditions Report</a>'
        )
        .replace(
            'http://www.avalanche.ca/pages/static-page/spring-conditions',
            '<a href="https://www.avalanche.ca/spring-conditions" target="_blank" rel="nofollow">Spring Conditions</a>'
        )
}

function earlySeason(message) {
    return message.replace(
        '- https://www.avalanche.ca/mountain-information-network',
        '<a href="https://www.avalanche.ca/mountain-information-network" target="_blank" rel="nofollow">Mountain Information Network</a>'
    )
}

function springSituation(message) {
    return message
        .replace(
            'http://www.mountainconditions.com.',
            '<a href="https://www.mountainconditions.ca" target="_blank" rel="nofollow">Mountain Conditions Report</a>'
        )
        .replace(
            '- http://www.avalanche.ca/pages/static-page/spring-conditions',
            '<a href="https://www.avalanche.ca/spring-conditions" target="_blank" rel="nofollow">Spring Conditions</a>'
        )
}

export default function messageFormatter(message, season) {
    switch (true) {
        case season.value.includes(Seasons.SPRING):
            return springSituation(message)

        case season.value.includes(Seasons.FALL):
            return earlySeason(message)

        case season.value.includes(Seasons.SUMMER):
            return offSeason(message)

        default:
            return message
    }
}
